var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save-money-2",
    transform: "translate(-5 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 24,
    height: 24,
    transform: "translate(5 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(5 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M151.156,10.312A5.156,5.156,0,1,0,146,5.156,5.162,5.162,0,0,0,151.156,10.312Zm0,0",
    transform: "translate(-139.156)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M90,186.875h4.043a6.615,6.615,0,0,1-1.8-1.875H90Zm0,0",
    transform: "translate(-85.781 -176.328)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M335.746,186.875h4.043V185h-2.242A6.616,6.616,0,0,1,335.746,186.875Zm0,0",
    transform: "translate(-320.008 -176.328)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M18.525,95a6.558,6.558,0,0,1-.31,2.812h2.973V102.5H2.813V97.812H5.785A6.559,6.559,0,0,1,5.475,95H0v10.312H24V95Zm0,0",
    transform: "translate(0 -90.547)",
    fill: "#fac668"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.98f8e73b.svg";
export { ForwardRef as ReactComponent };